var map = {
	"./acetyleen.jpg": 5336,
	"./argon.jpg": 2633,
	"./default.jpg": 6763,
	"./heftruckgas.jpg": 3477,
	"./helium.jpg": 8065,
	"./koolzuur.jpg": 4385,
	"./koudemiddelen.jpg": 9466,
	"./menggassen.jpg": 970,
	"./propaan.jpg": 949,
	"./stikstof.jpg": 7660,
	"./waterstof.jpg": 578,
	"./zuurstof.jpg": 505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1010;